import { Component, ElementRef, Input, SimpleChanges, ViewChild, Inject, LOCALE_ID } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { VacanteResumen } from 'src/app/core/Interfaces/vacantes/vacante-resumen.interface';
import { VacantesResultados, Vacantes } from "src/app/core/Interfaces/vacantes/vacantes-resultado.interface";
import { JobCardType } from './job-card-type.enum';
import { Router } from '@angular/router';

declare var bootstrap: any;
@Component({
  selector: 'job-card',
  templateUrl: './job-card.component.html',
  styleUrl: './job-card.component.scss',
  standalone: false
})

export class JobCardComponent {

  topJobs: Vacantes[] = [];
  jobOpeningsRows: Vacantes[][] = [];
  @ViewChild('carousel') carouselElement!: ElementRef;
  @Input() jobOpenings: any[] = [];
  @Input() showCarousel: boolean = false;
  @Input() type: JobCardType = JobCardType.Top;
  constructor(@Inject(LOCALE_ID) public locale: string, private translate: TranslateService, private router: Router) {
    this.locale = 'es'; 
  }
  ngAfterViewInit() {
    const carouselElement = document.querySelector('#carouselExampleControls');
    if (this.showCarousel) {
      if (carouselElement) {
        const carousel = new bootstrap.Carousel(carouselElement, {
          interval: 50000, // Cambia cada 2 segundos
          ride: 'carousel'
        });

      } else {
        console.error('❌ No se encontró el carousel en el DOM.');

      }
      setTimeout(() => {
        if (this.carouselElement) {
          new bootstrap.Carousel(this.carouselElement.nativeElement, {
            interval: 70000, // Cambia cada 3 segundos
            ride: 'carousel'
          });
        }
      }, 500);
    }

  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['jobOpenings']) {
      this.groupRowJobOpenings();
    }
  }



  groupRowJobOpenings() {
    this.jobOpeningsRows = this.jobOpenings.reduce<Vacantes[][]>((rows, item, index) => {

      if (index % 4 === 0) rows.push([item]);
      else rows[rows.length - 1].push(item);
      return rows;
    }, []);
  }

  redirectToSearch(id: number, job: string) {
    this.router.navigate(['/buscador'], { 
      queryParams: { id, job }
    });
  }


}
